import React, { act, useEffect, useRef, useState } from "react";
import {
    Box, Button, Container, Grid, Paper, Typography, TextField, FormControl,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    DialogActions,
    Divider,
    MenuItem,
    FormHelperText,
    Select,
    FormControlLabel,
    Checkbox,
    TableCell,
    TableRow,
    TableHead,
    TableBody,
    FormLabel,
    RadioGroup,
    Radio,
    InputAdornment
} from "@mui/material";
import { set, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import PageContainer from "./Pagecontainer";
import { IconAlertTriangle, IconCheck, IconCopy, IconX } from "@tabler/icons-react";
import { BeatLoader } from "react-spinners";
import ScheduleDemo from "./demo";
import logospg from '../Images/LOGO_SPG.png'
import logo from '../Images/logo-dark.png'
import { Card, Table } from "react-bootstrap";
import html2pdf from 'html2pdf.js';
import Cookies from 'js-cookie';
import 'react-credit-cards/es/styles-compiled.css'
import { PaymentIcon, detectCardType } from 'react-svg-credit-card-payment-icons';
const Billing = () => {
    const { register, handleSubmit, formState: { errors }, trigger, setValue, watch,reset,clearErrors } = useForm();
    const navigate = useNavigate();
    const params = new URLSearchParams(window.location.search);
    const planid = params.get("id");
    const selectedPlan = params.get("selectedplanid");
    const Type = params.get('type')
    const CurrentPlanid = params.get("currentplanid");
    const planName = params.get("planName");
    const is_custom = params.get("is_custom")
    const ReportCount = params.get("ReportCount")
    const couponCode = params.get("couponCode")
    const userInfo = JSON.parse(Cookies.get("user-info"));
    const [activeplanid, setActivePlanId] = useState('')
    const [copied, setCopied] = useState(false);
    const [open, setopen] = useState(false);
    const [Errorpopup, setErrorpopup] = useState(false)
    const [ErrorMessage, setErrorMessage] = useState('')
    const [loader, setLoader] = useState(false)
    const [orderId, setOrderId] = useState('')
    const [CheckError,setCheckError]=useState("")
    const [InvoiceData, setInvoiceData] = useState();
    const invoiceRef = useRef();
    const userinfo = JSON.parse(Cookies.get("user-info")); 
    const [Hidecard,setHideCard]= useState(false)
    const [PaymentId,setPaymentId] = useState("")
    const [ProfileId,setProfileId] = useState("")
    // const onSubmit = async (data) => {
    //     if (!acceptedTerms) {
    //         setCheckError("By submitting , you agree to our Terms of Service and Privacy Policy");
    //         return;
    //       }
    //     // const sanitizeCard = (num) => num.replace(/\s+/g, '');
    //     const sanitizeCard = (num) => (typeof num === 'string' ? num.replace(/\s+/g, '') : '');
    //     setLoader(true)
    //     let req =
    //     {
    //         first_name: data.name,
    //         last_name: data.lastname,
    //         email: data.email,
    //         mobile: data.mobile,
    //         address: data.address,
    //         country: data.country,
    //         city: data.city,
    //         state: data.state,
    //         zip: data.postalCode,
    //         user_id: userInfo?.id,
    //         // amount:Price,
    //         selected_plan_id: selectedPlan,
    //         // card_number: data.cardNumber,
    //         card_number: !Hidecard? "":sanitizeCard(data.cardNumber),
    //         expiry_date: !Hidecard? "":`${data.expiryMonth}/${data.expiryYear}`,
    //         cvv_code: !Hidecard? "":data.cvv,
    //         // current_subscription_id: CurrentPlanid,
    //         // description: data.description,
    //         // order_id: planid,
    //         // type: Type
    //         is_custom:is_custom,
    //         project_count:ReportCount ,
    //          ...(CurrentPlanid && { current_subscription_id: CurrentPlanid }),
    //          card_exists:Hidecard? false:true,
    //          customer_payment_profile_id:ProfileId,
    //          id:PaymentId
    //     }
    //     try {
    //         const config2 = {
    //             headers: { Authorization: `gAAAAABmpzmxUPtDE5__xR3VyJ8zR-2y9NeVxnM6pGqfgdR2UuC6ehPsn1RoCGFIZlDhEIu7P67WVP8ktyfYtFFZB63B4wGNCQ==` }
    //         }
    //         const response = await axios.post(`${process.env.REACT_APP_API_URL2}/apiV1/buy-subscription/`, req, config2);
    //         console.log(response);
    //         if (response.status == 200) {
    //             setLoader(false)
    //             getInvoiceData(response.data?.subscription_id);
    //         }

    //     } catch (e) {
    //         console.log(e);
    //         setLoader(false)
    //         setErrorpopup(true)
    //         setErrorMessage(e?.response?.data?.message)
    //     }
    // };
    const [alertPopUp, setAlretPopUp] = useState(false);
    const [formData, setFormData] = useState(null); 

    const onSubmit = async (data) => {
        if (!acceptedTerms) {
            setCheckError("By submitting, you agree to our Terms of Service and Privacy Policy");
            return;
        }

        const sanitizeCard = (num) => (typeof num === 'string' ? num.replace(/\s+/g, '') : '');

        const req = {
            first_name: data.name,
            last_name: data.lastname,
            email: data.email,
            mobile: data.mobile,
            address: data.address,
            country: data.country,
            city: data.city,
            state: data.state,
            zip: data.postalCode,
            user_id: userInfo?.id,
            selected_plan_id: selectedPlan,
            card_number: !Hidecard ? "" : sanitizeCard(data.cardNumber),
            expiry_date: !Hidecard ? "" : `${data.expiryMonth}/${data.expiryYear}`,
            cvv_code: !Hidecard ? "" : data.cvv,
            is_custom: is_custom,
            project_count: ReportCount,
            ...(CurrentPlanid && { current_subscription_id: CurrentPlanid }),
            card_exists: Hidecard ? false : true,
            customer_payment_profile_id: ProfileId,
            coupon_code: couponCode ? couponCode : null,
            ...(couponCode && { is_promocode: true }),
            id: PaymentId,
        };

        setFormData(req);
        setAlretPopUp(true);
    };
    const handleConfirmPayment = async () => {
        setLoader(true);
        setAlretPopUp(false);

        try {
            const config2 = {
                headers: {
                    Authorization: `gAAAAABmpzmxUPtDE5__xR3VyJ8zR-2y9NeVxnM6pGqfgdR2UuC6ehPsn1RoCGFIZlDhEIu7P67WVP8ktyfYtFFZB63B4wGNCQ==`,
                },
            };
            const response = await axios.post(`${process.env.REACT_APP_API_URL2}/apiV1/buy-subscription/`, formData, config2);

            if (response.status === 200) {
                setLoader(false);
                getInvoiceData(response.data?.subscription_id);
            }
        } catch (e) {
            console.log(e);
            setLoader(false);
            setErrorpopup(true);
            setErrorMessage(e?.response?.data?.message);
        }
    };

const getbillingAddress = async () => {
    try{
        const config2 = {
          headers: {
              Authorization: `gAAAAABmpzmxUPtDE5__xR3VyJ8zR-2y9NeVxnM6pGqfgdR2UuC6ehPsn1RoCGFIZlDhEIu7P67WVP8ktyfYtFFZB63B4wGNCQ==`,
          },
      };
          const response = await axios.get(`${process.env.REACT_APP_API_URL2}/apiV1/get-billing_address/?user_id=${userInfo?.id}`,config2);
          if (response.status == 200) {
            console.log(response.data);
            const nameParts = response.data[0].customer__full_name?.trim().split(" ") || [];
            const firstName = response.data[0]?.first_name || "";
            const lastName = response.data[0]?.last_name || "";
              setValue("name", firstName);
              setValue("lastname",lastName);
              setValue("email", response.data[0]?.customer__corp_email);
              setValue("mobile", response.data[0]?.phone_number);
              setValue("address", response.data[0]?.address_line_1);
              setValue("country", response.data[0]?.country);
              setValue("state", response.data[0]?.state);
              setValue("city", response.data[0]?.city);
              setValue("postalCode", response.data[0]?.postal_code);
              setValue("description", response.data[0]?.description);}
       
        }catch(error){
          console.log(error)
        }
    }
    useEffect(() => {
        if (selectedPlan) {
            getbillingAddress();
        }
    }, [selectedPlan]);
    const getInvoiceData = async (Id) => {
        setLoader(true)
        try {
            const config2 = {
                headers: {
                    Authorization:
                        'gAAAAABmpzmxUPtDE5__xR3VyJ8zR-2y9NeVxnM6pGqfgdR2UuC6ehPsn1RoCGFIZlDhEIu7P67WVP8ktyfYtFFZB63B4wGNCQ=='
                }
            };
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL2}/apiV1/user-invoice/?user_id=${userinfo.id}&id=${Id}`,
                config2
            );
            if (response.status === 200) {
                setInvoiceData(response.data);
                setTimeout(() => {
                    generateAndSendInvoice(Id)
                }, 1000);
            }
        } catch (err) {
            console.log(err?.response?.data?.message);
            setLoader(false)

        }
    };
    const userinfo1 = async () => {
        try {
          const config = axios.defaults.headers.common = { 'Authorization': `Bearer ${sessionStorage.getItem("AdminToken")}` }
          const response = await axios.get('/apiV1/user-info/', config);
          console.log(response.data);
          if (response.status == 200) {
            sessionStorage.setItem("user-info", JSON.stringify(response.data))
            Cookies.set('user-info', JSON.stringify(response.data));
          }
        } catch (error) {
          console.error('Error generating test:', error.response ? error.response.data : error.message);
        }
      }
    const generateAndSendInvoice = async (Id) => {
        if (!invoiceRef?.current) {
            console.warn("Invoice ref missing");
            return;
        }

        try {
            await new Promise((res) => setTimeout(res, 500));

            const opt = {
                margin: 0,
                filename: 'invoice.pdf',
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: {
                    scale: 2,
                    useCORS: true,
                    allowTaint: false,
                    logging: false,
                },
                jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
            };

            const pdfBase64 = await html2pdf()
                .from(invoiceRef.current)
                .set(opt)
                .outputPdf('datauristring');
            const req = {
                email: userInfo?.email,
                base64_file: pdfBase64,
            };

            const response = await axios.post(
                `${process.env.REACT_APP_API_URL2}/apiV1/send-invoice-email/`,
                req,
                {
                    headers: {
                        Authorization: '', 
                        'Content-Type': 'application/json',
                    },
                }
            );

            if (response.status === 200) {
                setLoader(false);
                setopen(true);
                userinfo1()
            } else {
                console.warn("Error", response.status);
            }

        } catch (err) {
            console.error("Error", err);
        }
    };

    const [acceptedTerms, setAcceptedTerms] = useState(false);

    const handleCheckboxChange = (event) => {
        const isChecked = event.target.checked;
        setAcceptedTerms(isChecked);
        if (isChecked) {
          setCheckError(""); 
        }
        else
        {
            setCheckError("By submitting, you agree to our Terms of Service and Privacy Policy"); 
        }
      };

const [selectedCardId, setSelectedCardId] = useState('');
const handleCardSelection = (id) => {
  setSelectedCardId(id);
    setValue("cardNumber", "", { shouldValidate: false });
    setValue("cardNumberFormatted", "", { shouldValidate: false });
    setValue("expiryYear", "", { shouldValidate: false });
    setValue("expiryMonth", "", { shouldValidate: false });
    setValue("cvv", "", { shouldValidate: false });
    clearErrors("cardNumber");
    clearErrors("expiryYear");
    clearErrors("expiryMonth");
    clearErrors("cvv");

  if (id === 'new') {
    setHideCard(true)
    // getbillingAddress()
    // reset()
    setProfileId("")
    setPaymentId('')
  } 
  else
  {
    // getbillingAddress()
    setHideCard(false)
    getData()
    // reset()
  }
};
const [SavedCards,setSavedCards] = useState("")
const [Nocard,setNocardData]= useState(false)
const getData = async () => {
        setLoader(true)
        try {
            const config2 = {
                headers: { Authorization: `gAAAAABmpzmxUPtDE5__xR3VyJ8zR-2y9NeVxnM6pGqfgdR2UuC6ehPsn1RoCGFIZlDhEIu7P67WVP8ktyfYtFFZB63B4wGNCQ==` }
              }
            const response = await axios.get(`${process.env.REACT_APP_API_URL2}/apiV1/get-card-details/?user_id=${userInfo.id} `,config2);
            if (response.status === 200) {
                setSavedCards(response?.data)
                setSelectedCardId(response?.data.credit_card?.id);
                setLoader(false)
                setPaymentId(response?.data?.credit_card?.id)
                setProfileId(response?.data?.customer_payment_profile?.customer_payment_profile_id)
            }
        } catch (err) {
            console.log(err);
            setLoader(false)
            if (err?.status === 404) {
            setNocardData(true);
            setHideCard(true)
        }
        }
    };
    
    useEffect(() => {
        getData();
    }, []);
    const [cardType, setCardType] = useState(null);
    const cardNumberValue = watch("cardNumberFormatted");
    useEffect(() => {
        if (cardNumberValue) {
            const detectedType = detectCardType(cardNumberValue.replace(/\D/g, ""));
            setCardType(detectedType);
        } else {
            setCardType(null);
        }
    }, [cardNumberValue]);
    return (
        <>
            <PageContainer>
            <ScheduleDemo showBanner={true} />
            {loader && (
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "100vh",
                                    width: "100vw",
                                    position: "fixed",
                                    top: 0,
                                    left: 0,
                                    backgroundColor: "rgba(255, 255, 255, 0.8)",
                                    zIndex: 9999,
                                }}
                            >
                                <BeatLoader color=" #07659c" size={20} />
                            </Box>
                        )}
                <Container >
                    <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                        Selected Business Ideas :  {planName}
                    </Typography>
                    <Paper sx={{ p: 4, mt:2, borderRadius: 2 }}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Grid container spacing={8}>
                                {/* Billing Address Section */}
                                <Grid item xs={12} md={6}>
                                    <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
                                        Billing Address
                                    </Typography>

                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <FormControl fullWidth sx={{ mb: 2 }}>
                                                <Typography variant="body2" sx={{ mb: 1 }}>First Name <span style={{ color: "red", fontSize: "15px" }}>*</span></Typography>
                                                <TextField
                                                    placeholder="Enter Name"
                                                    {...register("name", { required: "First Name is required" ,
                                                        validate: value =>
                                                            value.trimStart() === value || "First Name should not start with a space",
                                                        pattern: {
                                                            value: /^[a-zA-Z\s]+$/,
                                                            message: "First Name should contain only letters and spaces",
                                                          },
                                                    })}
                                                    error={!!errors.name}
                                                    helperText={errors.name?.message}
                                                    onKeyUp={() => trigger("name")}
                                                    disabled={loader}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormControl fullWidth sx={{ mb: 2 }}>
                                                <Typography variant="body2" sx={{ mb: 1 }}>Last Name <span style={{ color: "red", fontSize: "15px" }}>*</span></Typography>
                                                <TextField
                                                    placeholder="Enter Name"
                                                    {...register("lastname", { required: "Last Name is required" ,
                                                        validate: value =>
                                                            value.trimStart() === value || "Last Name should not start with a space",
                                                        pattern: {
                                                            value: /^[a-zA-Z\s]+$/,
                                                            message: "Last Name should contain only letters and spaces",
                                                          },
                                                    })}
                                                    error={!!errors.lastname}
                                                    helperText={errors.lastname?.message}
                                                    onKeyUp={() => trigger("lastname")}
                                                    disabled={loader}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>

                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <FormControl fullWidth sx={{ mb: 2 }}>
                                                <Typography variant="body2" sx={{ mb: 1 }}>Email</Typography>
                                                <TextField
                                                    placeholder="Enter Email"
                                                    defaultValue={userInfo?.email}
                                                    disabled={true}
                                                    {...register("email", {
                                                        required: "Email is required",
                                                        pattern: {
                                                            value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                                                            message: "Invalid email format"
                                                        }
                                                    })}
                                                    onKeyUp={() => trigger("email")}
                                                    error={!!errors.email}
                                                    helperText={errors.email?.message}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormControl fullWidth sx={{ mb: 2 }}>
                                                <Typography variant="body2" sx={{ mb: 1 }}>Mobile <span style={{ color: "red", fontSize: "15px" }}>*</span></Typography>
                                                <TextField
                                                        placeholder="Enter Mobile"
                                                        {...register("mobile", {
                                                            required: "Mobile Number is required",
                                                            pattern: {
                                                            value: /^(?! )[+0-9()\-\s]{8,20}$/, // No leading space; allow +()- and digits
                                                            message: "Enter a valid number (no space at start, allow +()- and digits)",
                                                            },
                                                            minLength: {
                                                            value: 8,
                                                            message: "Mobile number must be at least 8 characters",
                                                            },
                                                            maxLength: {
                                                            value: 20,
                                                            message: "Mobile number must not exceed 20 characters",
                                                            },
                                                        })}
                                                        error={!!errors.mobile}
                                                        helperText={errors.mobile?.message}
                                                        onKeyUp={() => trigger("mobile")}
                                                        disabled={loader}
                                                        inputProps={{
                                                            maxLength: 20,
                                                            inputMode: "tel",
                                                        }}
                                                        />
                                                {/* <TextField
                                                    placeholder="Enter Mobile"
                                                    {...register("mobile", {
                                                        required: "Mobile Number is required",
                                                        pattern: {
                                                            value: /^[0-9]+$/,
                                                            message: "Only numeric values are allowed",
                                                        },
                                                        minLength: {
                                                            value: 10,
                                                            message: "Mobile number must be at least 10 digits",
                                                        },
                                                        maxLength: {
                                                            value: 12,
                                                            message: "Mobile number must not exceed 12 digits",
                                                        },
                                                    })}
                                                    error={!!errors.mobile}
                                                    helperText={errors.mobile?.message}
                                                    onKeyUp={() => trigger("mobile")}
                                                    disabled={loader}
                                                    inputProps={{
                                                        maxLength: 12,
                                                      }}
                                                /> */}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <FormControl fullWidth sx={{ mb: 2 }}>
                                                <Typography variant="body2" sx={{ mb: 1 }}>Country <span style={{ color: "red", fontSize: "15px" }}>*</span></Typography>
                                                <TextField
                                                    placeholder="Enter Country"
                                                    {...register("country", { required: "Country is required",
                                                        validate: value =>
                                                            value.trimStart() === value || "Country should not start with a space",
                                                        pattern: {
                                                            value: /^[a-zA-Z\s]+$/,
                                                            message: "Country should contain only letters and spaces",
                                                          },
                                                     })}
                                                    error={!!errors.country}
                                                    helperText={errors.country?.message}
                                                    onKeyUp={() => trigger("country")}
                                                    disabled={loader}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormControl fullWidth sx={{ mb: 2 }}>
                                                <Typography variant="body2" sx={{ mb: 1 }}>State <span style={{ color: "red", fontSize: "15px" }}>*</span></Typography>
                                                <TextField
                                                    placeholder="State"
                                                    {...register("state", { required: "State is required" ,
                                                        validate: value =>
                                                            value.trimStart() === value || "State should not start with a space",
                                                        pattern: {
                                                            value: /^[a-zA-Z\s]+$/,
                                                            message: "State should contain only letters and spaces",
                                                          },
                                                    })}
                                                    error={!!errors.state}
                                                    helperText={errors.state?.message}
                                                    onKeyUp={() => trigger("state")}
                                                    disabled={loader}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>



                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <FormControl fullWidth sx={{ mb: 2 }}>
                                                <Typography variant="body2" sx={{ mb: 1 }}>City <span style={{ color: "red", fontSize: "15px" }}>*</span></Typography>
                                                <TextField
                                                    placeholder="Enter City"
                                                    {...register("city", {
                                                        required: "City is required",
                                                        validate: value =>
                                                            value.trimStart() === value || "City should not start with a space",
                                                        pattern: {
                                                            value: /^[a-zA-Z\s]+$/,
                                                            message: "City should contain only letters and spaces",
                                                          },
                                                    })}
                                                    error={!!errors.city}
                                                    helperText={errors.city?.message}
                                                    onKeyUp={() => trigger("city")}
                                                    disabled={loader}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormControl fullWidth sx={{ mb: 2 }}>
                                                <Typography variant="body2" sx={{ mb: 1 }}>ZIP Code <span style={{ color: "red", fontSize: "15px" }}>*</span></Typography>
                                                <TextField
                                                    placeholder="Enter ZIP Code"
                                                    {...register("postalCode", {
                                                        required: "ZIP Code is required",
                                                        pattern: {
                                                            value: /^[0-9]{5,6}$/,
                                                            message: "ZIP Code must be 5 or 6 digits"

                                                        }
                                                    })}
                                                    error={!!errors.postalCode}
                                                    helperText={errors.postalCode?.message}
                                                    onKeyUp={() => trigger("postalCode")}
                                                    disabled={loader}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                    <FormControl fullWidth sx={{ mb: 2 }}>
                                        <Typography variant="body2" sx={{ mb: 1 }}>Address <span style={{ color: "red", fontSize: "15px" }}>*</span></Typography>
                                        <TextField
                                            placeholder="Address "
                                            {...register("address", { required: "Address is required" ,
                                                validate: value =>
                                                    value.trimStart() === value || "Address should not start with a space",
                                                maxLength: {
                                                value: 50,
                                                message: "Address cannot exceed 50 characters",  
                                                },
                                            })}
                                            error={!!errors.address}
                                            helperText={errors.address?.message}
                                            onKeyUp={() => trigger("address")}
                                            disabled={loader}
                                        />
                                    </FormControl>
                                    {/* <FormControl fullWidth sx={{ mb: 2 }}>
                                        <Typography variant="body2" sx={{ mb: 1 }}>Description <span style={{ color: "red", fontSize: "15px" }}>*</span></Typography>
                                        <TextField
                                            placeholder="Enter Description"
                                            {...register("description", {required: "description is required" ,
                                                validate: value =>
                                                  !value || value.trimStart() === value || "Description should not start with a space"
                                              })}
                                            error={!!errors.description}
                                            helperText={errors.description?.message}
                                            onKeyUp={() => trigger("description")}
                                            disabled={loader}
                                        />
                                    </FormControl> */}
                                </Grid>

                                {/* Payment Section */}
                                <Grid item xs={12} md={6}>
                                    
                                    <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
                                        Payment Details
                                    </Typography>
                                     <Typography sx={{fontSize:"13px",mb:1,color:"#c53131"}}>Note : All Amex payments have been subject to a 4% fee since January 1, 2016.</Typography>
                                    {!Nocard&&<Box sx={{border:"1px solid #076599",borderRadius:"12px",padding:"10px 15px",mb:2}}>
                                        <FormLabel component="legend">Select Payment Method</FormLabel>
                                        <RadioGroup value={selectedCardId} onChange={(e) => handleCardSelection(e.target.value)}>
                                            
                                           <FormControlLabel
                                            key={SavedCards?.credit_card?.id}
                                            value={SavedCards?.credit_card?.id}
                                            control={<Radio />}
                                            label={
                                                <Box sx={{ display:"flex",alignItems: 'center', gap: 1 }}>
                                                <PaymentIcon type={SavedCards?.credit_card?.card_type}  sx={{mt:2}}/>
                                                <Typography variant="body2" component="span" className="font-medium"> ••••  {SavedCards?.credit_card?.card_number} - Expires {SavedCards?.credit_card?.expiry_date}</Typography>
                                                </Box>
                                            }
                                            />

                                            <FormControlLabel value="new" control={<Radio />} label="Use a new card" />
                                        </RadioGroup></Box> }
                                         {Hidecard &&  
                                        <> <FormControl fullWidth sx={{ mb: 2}}>
                                        <Typography variant="body2" sx={{ mb: 1 }}>Card Number <span style={{ color: "red", fontSize: "15px" }}>*</span></Typography>
                                        <TextField
                                            sx={{ paddingRight: "0px" }}
                                            placeholder="Card Number"
                                            value={watch("cardNumberFormatted") || ""}
                                            {...register("cardNumber", {
                                                required: "Card number is required",
                                                validate: (value) => {
                                                    const raw = value.replace(/\s/g, ""); 
                                                    if (raw.length < 13) return "Card number must be at least 13 digits";
                                                    if (raw.length > 16) return "Card number cannot exceed 16 digits";
                                                    return true;
                                                },
                                            })}
                                            onChange={(e) => {
                                                const rawValue = e.target.value.replace(/\D/g, "").slice(0, 16); 
                                                const formattedValue = rawValue.replace(/(.{4})/g, "$1 ").trim();
                                                setValue("cardNumber", rawValue);
                                                setValue("cardNumberFormatted", formattedValue);
                                                trigger("cardNumber");
                                            }}
                                            error={!!errors.cardNumber}
                                            helperText={errors.cardNumber?.message}
                                            disabled={loader}
                                            InputProps={{
                                                endAdornment: cardType ? (
                                                    <InputAdornment position="start" sx={{ marginRight: 0 }}>
                                                        <PaymentIcon type={cardType} width={50} />
                                                    </InputAdornment>
                                                ) : null,
                                            }}
                                        />


                                    </FormControl>

                                    {/* <FormControl fullWidth sx={{ mb: 2 }}>
                                <Typography variant="body2" sx={{ mb: 1 }}>Cardholder Name</Typography>
                                <TextField
                                    placeholder="Cardholder Name"
                                    {...register("cardHolderName", { required: "Cardholder name is required" })}
                                    error={!!errors.cardHolderName}
                                    helperText={errors.cardHolderName?.message}
                                    onKeyUp={() => trigger("cardHolderName")}
                                />
                            </FormControl> */}
                                <FormControl fullWidth sx={{ mb: 2 }}>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    Expiry Date <span style={{ color: "red", fontSize: "15px" }}>*</span>
                                </Typography>

                                <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <Select
                                        fullWidth
                                        value={watch("expiryYear") || ""}
                                        {...register("expiryYear", {
                                        required: "Year is required",
                                        })}
                                        onChange={(e) => {setValue("expiryYear", e.target.value);trigger("expiryYear")}}
                                        displayEmpty
                                        sx={{
                                            maxHeight: "40px",
                                        }}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 450, 
                                                    overflowY: "auto",
                                                },
                                            },
                                        }}
                                    >
                                        <MenuItem value="" disabled>
                                        Year
                                        </MenuItem>
                                        {Array.from({ length: 10 }, (_, i) => {
                                        const year = new Date().getFullYear() + i;
                                        return (
                                            <MenuItem key={year} value={year}>
                                            {year}
                                            </MenuItem>
                                        );
                                        })}
                                    </Select>
                                    {errors.expiryYear && (
                                        <FormHelperText error>{errors.expiryYear.message}</FormHelperText>
                                    )}
                                    </Grid>
                                    <Grid item xs={6}>
                                    <Select
                                        fullWidth
                                        value={watch("expiryMonth") || ""}
                                        {...register("expiryMonth", {
                                        required: "Month is required",
                                        validate: (value) => {
                                            const selectedYear = parseInt(watch("expiryYear"));
                                            const currentYear = new Date().getFullYear();
                                            const currentMonth = new Date().getMonth() + 1;
                                            const selectedMonth = parseInt(value);
                                        
                                            if (
                                              selectedYear === currentYear &&
                                              selectedMonth <= currentMonth - 1
                                            ) {
                                              return "Please select a future month";
                                            }
                                        
                                            return true;
                                          },
                                        })}
                                        onChange={(e) => {setValue("expiryMonth", e.target.value);trigger("expiryMonth")}}
                                        displayEmpty
                                        sx={{
                                            maxHeight: "40px",
                                        }}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 450, 
                                                    overflowY: "auto",
                                                },
                                            },
                                        }}
                                    >
                                        <MenuItem value="" disabled>
                                        Month
                                        </MenuItem>
                                        {Array.from({ length: 12 }, (_, i) => (
                                        <MenuItem key={i + 1} value={(i + 1).toString().padStart(2, "0")}>
                                            {(i + 1).toString().padStart(2, "0")}
                                        </MenuItem>
                                        ))}
                                    </Select>
                                    {errors.expiryMonth && (
                                        <FormHelperText error>{errors.expiryMonth.message}</FormHelperText>
                                    )}
                                    </Grid>

                                    
                                </Grid>
                                </FormControl>

                                    {/* <FormControl fullWidth sx={{ mb: 2 }}>
                                        <Typography variant="body2" sx={{ mb: 1 }}>Expiry Date <span style={{ color: "red", fontSize: "15px" }}>*</span></Typography>
                                        <TextField
                                            placeholder="MM/YY"
                                            value={watch("expiryDate") || ""}
                                            {...register("expiryDate", {
                                                required: "Expiry Date is required",})}
                                            onChange={(e) => {
                                                let input = e.target.value.replace(/\D/g, "").slice(0, 6);
                                                if (input.length >= 3) {
                                                    input = input.slice(0, 2) + '/' + input.slice(2); 
                                                }
                                                setValue("expiryDate", input);
                                                trigger("expiryDate");
                                            }}
                                            error={!!errors.expiryDate}
                                            helperText={errors.expiryDate?.message}
                                            disabled={loader}
                                        />

                                    </FormControl> */}

                                    <FormControl fullWidth sx={{ mb: 2 }}>
                                        <Typography variant="body2" sx={{ mb: 1 }}>CVV <span style={{ color: "red", fontSize: "15px" }}>*</span></Typography>
                                        <TextField
                                            placeholder="CVV"
                                            {...register("cvv", {
                                                required: "CVV is required",
                                                pattern: {
                                                    value: /^[0-9]{3,4}$/,
                                                    message: "CVV must be 3 or 4 digits"
                                                }
                                            })}
                                            error={!!errors.cvv}
                                            helperText={errors.cvv?.message}
                                            onKeyUp={() => trigger("cvv")}
                                            disabled={loader}
                                            inputProps={{ maxLength: 4 }}
                                        />
                                    </FormControl></> 
                                     }
                                <FormControlLabel
                                    control={
                                    <Checkbox
                                        checked={acceptedTerms}
                                        onChange={handleCheckboxChange}
                                        color="primary"
                                    />
                                    }
                                    label="I accept the Terms and Conditions"
                                />
                                <FormHelperText error>{CheckError?CheckError:""}</FormHelperText>
                                 {/* {Hidecard && <Cards
                                        cvc={cardInfo.cvc}
                                        expiry={cardInfo.expiry}
                                        focused={cardInfo.focus}
                                        // name={cardInfo.name}
                                        number={cardInfo.number}
                                    /> } */}
                                </Grid>
                            </Grid>

                            {/* Submit and Cancel Button */}
                            <Box sx={{ mt: 4, display: "flex", justifyContent: "flex-end", gap: 2 }}>
                                <Button variant="contained" color="primary" onClick={() => navigate(-1)} disabled={loader}>
                                    Cancel
                                </Button>
                                <Button type="submit" variant="contained" color="primary" className="button2" disabled={loader}>
                                    {loader ? <BeatLoader color="#fff" /> : "Submit"}
                                </Button>
                            </Box>
                        </form>

                    </Paper>
                    <Grid sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '210mm',
                        minHeight: '297mm',
                        backgroundColor: '#fff',
                        zIndex: 9999,
                        opacity: 1,
                        visibility: 'hidden',
                        pointerEvents: 'none',
                    }}>
                        <Box
                            ref={invoiceRef}
                            style={{ padding: 16 }}

                        >
                            <Card style={{ padding: 16 }} >
                                <Grid container spacing={2} alignItems="center" justifyContent="space-between" mb={2}>
                                    {/* Left: Company Info */}
                                    <Grid item xs={12} md={4}>
                                        <img src={logospg} alt="Logo" style={{ width: 120, maxWidth: '100%' }} crossOrigin="anonymous" />
                                        <Typography fontWeight={600}>
                                            {InvoiceData?.configuration__company_name}
                                        </Typography>
                                        <Box display="flex" gap={1} alignItems="start">
                                            {/* <LocationOn fontSize="small" color="action" /> */}
                                            <Box>
                                                <Typography variant="body2">{InvoiceData?.configuration__address_line_1}</Typography>
                                                <Typography variant="body2">{InvoiceData?.configuration__address_line_2}</Typography>
                                            </Box>
                                        </Box>
                                        <Box display="flex" gap={1} alignItems="center">
                                            {/* <Mail fontSize="small" color="action" /> */}
                                            <Typography variant="body2">
                                                {InvoiceData?.configuration__company_email}
                                            </Typography>
                                        </Box>
                                        <Box display="flex" gap={1} alignItems="center">
                                            {/* <Phone fontSize="small" color="action" /> */}
                                            <Typography variant="body2">{InvoiceData?.configuration__mobile_no}</Typography>
                                        </Box>
                                    </Grid>

                                    {/* Center: Logo */}
                                    <Grid item xs={12} md={4} textAlign="center">
                                        <Box mb={1}>
                                            <img src={logo} alt="Logo" style={{ width: 150, maxWidth: '100%' }} crossOrigin="anonymous" />
                                        </Box>
                                        <Typography variant="h5" fontWeight={700}>
                                            Invoice
                                        </Typography>
                                    </Grid>

                                    {/* Right: Invoice Details */}
                                    <Grid item xs={12} md={4} textAlign={{ xs: 'left', md: 'right' }}>
                                        <Typography variant="body2">
                                            <strong>Invoice Number:</strong> {InvoiceData?.invoice_number}
                                        </Typography>
                                        <Typography variant="body2">
                                            <strong>Date:</strong>{" "}
                                            {InvoiceData?.date
                                                ? new Date(InvoiceData.date).toLocaleDateString('en-GB').replaceAll('/', '-')
                                                : '--'}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Box border="2px solid rgb(239, 239, 241)" borderRadius={1} p={2} mb={4}>
                                    <Typography variant="h6" fontWeight={600} textAlign="center" mb={2}>
                                        Customer Information
                                    </Typography>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="body2">Company Name :</Typography>
                                            <Typography variant="body2">Contact Name :</Typography>
                                            <Typography variant="body2">Email Id :</Typography>
                                            <Typography variant="body2">Address :</Typography>
                                            <Typography variant="body2">Phone :</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="body2">{InvoiceData?.customer__company_name || '—'}</Typography>
                                            <Typography variant="body2">{InvoiceData?.customer__full_name || '—'}</Typography>
                                            <Typography variant="body2">{InvoiceData?.customer__corp_email || '—'}</Typography>
                                            <Typography variant="body2">
                                                {(InvoiceData?.customer_add_info?.[0]?.address_line_1 || '—') +
                                                    (InvoiceData?.customer_add_info?.[0]?.city ? `, ${InvoiceData.customer_add_info[0].city}` : '') +
                                                    (InvoiceData?.customer_add_info?.[0]?.postal_code ? `, ${InvoiceData.customer_add_info[0].postal_code}` : '')}
                                            </Typography>
                                            <Typography variant="body2">{InvoiceData?.customer_add_info?.[0]?.phone_number || '—'}</Typography>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#004466' }}>
                <TableCell sx={{ color: '#fff' }}>S.NO</TableCell>
                <TableCell sx={{ color: '#fff' }}>PLAN TYPE</TableCell>
                <TableCell sx={{ color: '#fff' }}>DESCRIPTION</TableCell>
                <TableCell sx={{ color: '#fff' }} align="center">QUANTITY</TableCell>
                <TableCell sx={{ color: '#fff' }} align="center">UNIT PRICE</TableCell>
                <TableCell sx={{ color: '#fff' }} align="right">PRICE</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>

              {/* MAIN LINE ITEM */}
              <TableRow>
                <TableCell>1</TableCell>
                <TableCell>{InvoiceData?.billing_info?.[0]?.item_name}</TableCell>
                <TableCell>
                  A Plan with {InvoiceData?.billing_info?.[0]?.no_of_projects_allowed} projects
                </TableCell>
                <TableCell align="center">
                  {InvoiceData?.billing_info?.[0]?.no_of_projects_allowed}
                </TableCell>
                <TableCell align="center">
                  $
                  {(InvoiceData?.billing_info?.[0]?.actual_amount /
                    InvoiceData?.billing_info?.[0]?.no_of_projects_allowed).toFixed(2)}
                </TableCell>
                <TableCell align="right">
                  ${InvoiceData?.billing_info?.[0]?.actual_amount}
                </TableCell>
              </TableRow>

              {/* SUMMARY SECTION */}
              <TableRow>
                <TableCell colSpan={6} sx={{ borderBottom: "none", paddingBottom: 0 }}>

                  <Box
                    sx={{
                      width: "320px",
                      ml: "auto",
                      mt: 2,
                      display: "flex",
                      flexDirection: "column",
                      gap: 1
                    }}
                  >

                    {/* TAX */}
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                      <Typography sx={{ fontWeight: 500 }}>
                        Tax ({InvoiceData?.tax_info?.tax_percent}%)
                      </Typography>
                      <Typography>
                        ${InvoiceData?.tax_info?.tax_price.toFixed(2)}
                      </Typography>
                    </Box>

                    {/* DISCOUNT */}
                    {InvoiceData?.is_promo_code === true && (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          mt: 1
                        }}
                      >
                        {/* LEFT SIDE — LABEL + BADGE */}
                        <Box sx={{ textAlign: "left" }}>
                          <Typography
                            sx={{
                              fontWeight: 600,
                              fontSize: "13px",
                              display: "flex",
                              alignItems: "center",
                              gap: "6px"
                            }}
                          >
                            Discount

                            {/* BADGE */}
                          (  <Box
                              sx={{
                                fontSize: "11px",
                                backgroundColor: "#e7ffeb",
                                color: "#0a7d0a",
                                padding: "2px 8px",
                                borderRadius: "6px",
                                fontWeight: 600,
                              }}
                            >
                              {InvoiceData?.billing_info?.[0]?.sub_promo_code}
                            </Box>

                            {/* DISCOUNT PERCENTAGE */}
                            <Typography
                              component="span"
                              sx={{
                                fontSize: "12px",
                                fontWeight: 500,
                                color: "#444"
                              }}
                            >
                              / {InvoiceData?.billing_info?.[0]?.promo_discount_value}%
                            </Typography>)
                          </Typography>
                        </Box>

                        {/* RIGHT SIDE — AMOUNT */}
                        <Typography sx={{ fontWeight: 600, fontSize: "13px" }}>
                          -${InvoiceData?.billing_info?.[0]?.sub_promo_discount_amount}
                        </Typography>
                      </Box>
                    )}


                    {/* GRAND TOTAL */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mt: 1,
                        borderTop: "1px solid #ddd",
                        pt: 1
                      }}
                    >
                      <Typography sx={{ fontWeight: 700 }}>GRAND TOTAL</Typography>
                      <Typography sx={{ fontWeight: 700 }}>
                        ${InvoiceData?.total_amount.toFixed(2)}
                      </Typography>
                    </Box>

                  </Box>

                </TableCell>
              </TableRow>

            </TableBody>
          </Table>
                                <Box textAlign="center" bgcolor="primary.lighter" borderRadius={2} >
                                    <Typography variant="h6" color="primary.dark" gutterBottom>
                                        Thank You for Your Purchase!
                                    </Typography>
                                </Box>

                            </Card>
                        </Box>
                    </Grid>
                </Container>
                <Dialog open={open} onClose={() => setopen(false)} maxWidth="xs" fullWidth>
                <DialogTitle sx={{ position: "relative" }}>
                        Payment Successful
                        <IconButton
                            aria-label="close"
                            onClick={()=>setopen(false)} 
                            sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <IconX />
                        </IconButton>
                        </DialogTitle>
                        <Divider/>
                    <DialogContent sx={{ textAlign: "center", p: 3 }}>
                        <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                                            <IconButton
                                              disableRipple
                                              sx={{
                                                backgroundColor: "#e6f4ea",
                                                padding: 3,
                                                "&:hover": { backgroundColor: "#c3e6cb" }
                                              }}
                                            >
                                              <IconCheck color="#28a745" size={50} />
                                            </IconButton>
                                          </Box>
                        <Typography variant="body1" sx={{ mb: 1 }}>
                            Your payment was processed successfully!
                        </Typography>
                        {/* <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: "#f5f5f5",
                                borderRadius: "8px",
                                p: 1,
                                mt: 2,
                            }}
                        >
                            <Typography variant="body2" sx={{ fontWeight: "bold", mr: 1 }}>
                                Transaction ID:
                            </Typography>
                            <IconButton onClick={handleCopy} sx={{ ml: 1 }}>
                                {copied ? <IconCheck color="success" /> : <IconCopy />}
                            </IconButton>
                        </Box> */}
                    </DialogContent>
                    <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
                        <Button variant="contained" color="primary" onClick={() => { setopen(false); navigate('/plans') }}>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={Errorpopup} maxWidth="xs" fullWidth>
                    <DialogTitle sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        fontWeight: "bold",
                    }}
                    >
                        <Typography>Payment Failed</Typography>
                        <IconX sx={{ fontSize: 30, ml: 1 }} onClick={() => setErrorpopup(false)} />
                    </DialogTitle>
                    <Divider />
                    <Box display="flex" justifyContent="center" alignItems="center">
                        <Box
                            sx={{
                                width: 60,
                                height: 60,
                                backgroundColor: '#fff3cd',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                borderRadius: '50%',
                                mt: 1
                            }}
                        >
                            <IconAlertTriangle size={32} color="#ff9800" />
                        </Box>
                    </Box>
                    <DialogContent sx={{ textAlign: "center", p: 3 }}>
                        <Typography variant="body1">
                            {ErrorMessage || "Transaction has been failed"}
                        </Typography>
                    </DialogContent>
                    <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
                        <Button variant="contained" color="error" onClick={() => setErrorpopup(false)}>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={alertPopUp} fullWidth>
                    <DialogTitle>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography sx={{ fontSize: "1.2rem", fontWeight: 600 }}>
                                Confirm Payment
                            </Typography>
                            <IconButton onClick={() => setAlretPopUp(false)}>
                                <IconX />
                            </IconButton>
                        </Box>
                    </DialogTitle>

                    <Divider />
                    <DialogContent sx={{ textAlign: "center", mt: 1 }}>
                        <Box
                            sx={{
                                width: 60,
                                height: 60,
                                backgroundColor: "#fdecea",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRadius: "50%",
                                margin: "0 auto 16px auto",
                            }}
                        >
                            <IconAlertTriangle size={32} color="#e57373" />
                        </Box>
                        <Typography variant="h6" fontWeight="bold" gutterBottom>
                            Proceed to Payment
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            Are you sure you want to proceed with the payment?
                        </Typography>
                    </DialogContent>
                    <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
                        <Button
                            variant="outlined"
                            color="inherit"
                            sx={{ width: 120 }}
                            onClick={() => setAlretPopUp(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            color="error"
                            sx={{ width: 120, backgroundColor: "#c63037" }}
                            onClick={handleConfirmPayment}
                        >
                            Confirm
                        </Button>
                    </DialogActions>
                </Dialog>

            </PageContainer>
        </>
    );
};

export default Billing;
